import { SignInData, SignUpData, SignOutData, SendRecoveryPasswordEmailDto, ResetPasswordDto, ChangePasswordDto } from '../../types/miscelaneos/auth.dto'
export const SIGN_IN = 'SIGN_IN'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR'

export const AUTO_SIGN_IN = 'AUTO_SIGN_IN'
export const AUTO_SIGN_IN_SUCCESS = 'AUTO_SIGN_IN_SUCCESS'
export const AUTO_SIGN_IN_ERROR = 'AUTO_SIGN_IN_ERROR'

export const SIGN_OUT = 'SIGN_OUT'
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS'
export const SIGN_OUT_ERROR = 'SIGN_OUT_ERROR'

export const SIGN_UP = 'SIGN_UP'
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS'
export const SIGN_UP_ERROR = 'SIGN_UP_ERROR'

export const SEND_PASSWORD_RECOVERY_EMAIL = "SEND_PASSWORD_RECOVERY_EMAIL"
export const SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS = "SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS"
export const SEND_PASSWORD_RECOVERY_EMAIL_ERROR = "SEND_PASSWORD_RECOVERY_EMAIL_ERROR"

export const RESET_PASSWORD = "RESET_PASSWORD"
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS"
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR"

export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR"
export const RESET_CHANGE_PASSWORD = "RESET_CHANGE_PASSWORD"

export interface SignIn {
  type: typeof SIGN_IN
  payload: SignInData
}
export interface SignInSuccess {
  type: typeof SIGN_IN_SUCCESS
  payload: boolean | string
}
export interface SignInError {
  type: typeof SIGN_IN_ERROR
  payload: boolean | string
}

export interface SignOut {
  type: typeof SIGN_OUT
  payload: SignOutData
}
export interface SignOutSuccess {
  type: typeof SIGN_OUT_SUCCESS
  payload: boolean | string
}
export interface SignOutError {
  type: typeof SIGN_OUT_ERROR
  payload: boolean | string
}

export interface SignUp {
  type: typeof SIGN_UP
  payload: SignUpData
}
export interface SignUpSuccess {
  type: typeof SIGN_UP_SUCCESS
  payload: boolean | string
}
export interface SignUpError {
  type: typeof SIGN_UP_ERROR
  payload: boolean | string
}

export interface SendPasswordRecoveryEmail {
  type: typeof SEND_PASSWORD_RECOVERY_EMAIL
  payload: SendRecoveryPasswordEmailDto
}
export interface SendPasswordRecoveryEmailSuccess {
  type: typeof SEND_PASSWORD_RECOVERY_EMAIL_SUCCESS
  payload: boolean | string
}
export interface SendPasswordRecoveryEmailError {
  type: typeof SEND_PASSWORD_RECOVERY_EMAIL_ERROR
  payload: boolean | string
}

export interface ResetPassword {
  type: typeof RESET_PASSWORD
  payload: ResetPasswordDto
}
export interface ResetPasswordSuccess {
  type: typeof RESET_PASSWORD_SUCCESS
  payload: boolean | string
}
export interface ResetPasswordError {
  type: typeof RESET_PASSWORD_ERROR
  payload: boolean | string
}


export interface ChangePassword {
  type: typeof CHANGE_PASSWORD
  payload: ChangePasswordDto
}
export interface ChangePasswordSuccess {
  type: typeof CHANGE_PASSWORD_SUCCESS
  payload: boolean | string
}
export interface ChangePasswordError {
  type: typeof CHANGE_PASSWORD_ERROR
  payload: boolean | string
}

export interface ResetChangePassword {
  type: typeof RESET_CHANGE_PASSWORD
  payload: null
}



export interface State {
  signin: {
    states: {
      loading: boolean
      success: boolean
      error: boolean | string
    }
  }
  signup: {
    states: {
      loading: boolean
      success: boolean
      error: boolean | string
    }
  }
  signout: {
    states: {
      loading: boolean
      success: boolean
      error: boolean | string
    }
  }
  passwordRecovery: {
    states: {
      loading: boolean
      success: boolean
      error: boolean | string
    }
  }
  sendPasswordRecoveryEmail: {
    states: {
      loading: boolean
      success: boolean
      error: boolean | string
    }
  }
  resetPassword: {
    states: {
      loading: boolean
      success: boolean
      error: boolean | string
    }
  }
  changePassword: {
    states: {
      loading: boolean
      success: boolean
      error: boolean | string
    }
  }
}

export const initialState: State = {
  signin: {
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  signup: {
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  signout: {
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  passwordRecovery: {
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  sendPasswordRecoveryEmail: {
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  resetPassword: {
    states: {
      loading: false,
      success: false,
      error: false,
    },
  },
  changePassword: {
    states: {
      loading: false,
      success: false,
      error: false,
    },
  }
}

export type Actions =
  | SignIn
  | SignInSuccess
  | SignInError
  | SignUp
  | SignUpSuccess
  | SignUpError
  | SignOut
  | SignOutSuccess
  | SignOutError
  | SendPasswordRecoveryEmail
  | SendPasswordRecoveryEmailSuccess
  | SendPasswordRecoveryEmailError
  | ResetPassword
  | ResetPasswordSuccess
  | ResetPasswordError
  | ChangePassword
  | ChangePasswordSuccess
  | ChangePasswordError
  | ResetChangePassword
